export type CenterPointCoordinate = { lat: number; lon: number }

export const DEFAULT_MAP_POSITION: CenterPointCoordinate = {
  lat: 37.904331,
  lon: 140.075683,
}

export const MIN_LATITUDE = 20.0000001
export const MAX_LATITUDE = 47.9999999

export const MIN_LONGITUDE = 118.0000001
export const MAX_LONGITUDE = 149.9999999
export const MAX_FLIGHT_AREA_COUNT = 3
